import type React from 'react'
import {
  type ForwardRefRenderFunction,
  type PropsWithoutRef,
  forwardRef as reactForwardRef,
} from 'react'

export type ForwardRefComponent<T, P> = React.ForwardRefExoticComponent<
  React.PropsWithoutRef<P> & React.RefAttributes<T>
> & {
  id?: string
}

export function forwardRef<T extends Element, P extends object>(
  component: React.ForwardRefRenderFunction<T, P>
) {
  return reactForwardRef(
    component as ForwardRefRenderFunction<T, PropsWithoutRef<P>>
  ) as ForwardRefComponent<T, P>
}
